import List from './List';
import Create from './Create';
import Edit from './Edit';
import Show from './Show';
import { gql } from '@apollo/client';

export default {
  name: 'positions',
  inputShow: gql`
    query positions($input: PositionQueryInput) {
      positions(input: $input) {
        id
        display_name
        high_risk
        __typename
      }
    }
  `,
  list: List,
  create: Create,
  edit: Edit,
  show: Show,
  options: {
    group: 'Misc',
    label: 'Positions',
  },
};
